<script>
import ExplorerProjectsNamespaces from '@shell/components/ExplorerProjectsNamespaces';
export default { components: { ExplorerProjectsNamespaces } };
</script>

<template><ExplorerProjectsNamespaces v-bind="$attrs" /></template>
